import React, { useState, useEffect, useCallback } from 'react';
import { iAxios } from '../../lib/utils';
import { Spinner } from '../common/Helper';
import { Link, useLocation, useParams } from 'react-router-dom';
import { StatusWidget } from '../widgets/JiraStatus';
import { JiraIssueItem as IssueItem } from './JiraIssue';
import Icon from '../ds/Icon';
import moment from 'moment';
export const useQuery = () => {
    const location = useLocation();
    return new URLSearchParams(location.search);
}

export const Jira = () => {
    const { projectId, componentId = 'EMPTY' } = useParams();
    const query = useQuery(); 

    const [jql, setJql] = useState('');
    const [search, setSearch] = useState('')
    const [issues, setIssues] = useState([]);
    const [sprintId, setSprintId] = useState('');
    const [runStatus, setRunStatus] = useState('');
    const [startId, setStartId] = useState('');
    const [createId, setCreateId] = useState('');
    const [versions, setVersions] = useState([]);
    const [token, setToken] = useState(localStorage.getItem('jira_token') || '');
    const [version, setVersion] = useState('');
    const [components, setComponents] = useState(null);
    const [sprints, setSprints] = useState([]);
    const [dialog, setDialog] = useState('');

    const [total, setTotal] = useState(0);
    const page = query.get('page') || '0';


    useEffect(() => {
        if (token && token !== '') {
            localStorage.setItem('jira_token', token);
        }
    }, [token])

    useEffect(() => {
        setComponents(null);
        iAxios.get(`/api/v1/jira`, {
            params: {
                path: `/rest/api/3/project/${projectId}/version`
            }
        }).then(resp => {
            setVersions(resp.data.values.filter(item => !item.released));
        }).catch(ex => {
            console.error(ex);
        });

        const boardId = '458';
        iAxios.get('/api/v1/jira', {
            params: {
                path: `/rest/agile/1.0/board/${boardId}/sprint`
            }
        }).then(resp => {
            setSprints(resp.data.values);
        });

        iAxios.get(`/api/v1/jira`, {
            params: {
                path: `/rest/api/3/project/${projectId}/components`
            }
        }).then(resp => {
            setComponents([{ name: 'EMPTY' }].concat(resp.data));
        }).catch(ex => {
            console.error(ex);
        });

    }, [projectId]);

    const renderRunStatus = async () => {
        setDialog('run-status')
    }


    useEffect(() => {
        const selected = sprints.find(item => item.id === sprintId);
        if (!selected) {
            return;
        }
        const ql = `project=SNT AND issuetype = TestCaseRun AND created > "${moment(selected.startDate).format('YYYY-MM-DD 00:00')}"  order by created ASC`;
        iAxios.get(`/api/v1/jira`, {
            params: {
                path: `/rest/api/3/search?maxResults=3&jql=${encodeURIComponent(ql)}`
            }
        }).then(resp => {
            if (resp.data.errorMessages) {
                alert(resp.data.errorMessages.join(','))
            } else {
                setStartId(resp.data.issues[0].id);
            }
        }).catch(ex => {
            console.error(ex);
        });

    }, [sprints, sprintId])


    useEffect(() => {
        if (!jql || jql === '') {
            return;
        }
        setIssues(null);
        iAxios.get(`/api/v1/jira`, {
            params: {
                path: `/rest/api/3/search?expand=renderedFields&startAt=${page * 50}&jql=${encodeURIComponent(jql)}`
            }
        }).then(resp => {
            if (resp.data.errorMessages) {
                alert(resp.data.errorMessages.join(','))
                setIssues([]);
                setTotal(0)
            } else {
                setIssues(resp.data.issues);
                setTotal(resp.data.total)
            }
        }).catch(ex => {
            console.error(ex);
        });
    }, [jql, page]);

    const qJql = query.get('jql');

    useEffect(() => {
        setTotal(0);
        if (componentId === 'jql') {
            setSearch(qJql);
            setJql(qJql);
            return;
        }
        let comp = componentId !== 'EMPTY' ? `"${componentId}"` : 'EMPTY';
        const ql = `project=${projectId} AND issuetype = Task AND component =${comp}`;
        setSearch(ql);
        setJql(ql);
    }, [componentId, projectId, qJql])


    const handleSearch = (e) => {
        e.preventDefault();
        const val = e.target.action; 
        const formData = new FormData(e.target);
        let search = new URLSearchParams(formData);
        let queryString = search.toString();
        // history.push(`/jira/${projectId}/jql?${queryString}`);
    }

    const handleBulkCreate = () => {
        if (runStatus !== '') {
            setRunStatus('');
            return;
        }
        if (!window.confirm('Are you sure you want bulk create test cases all issues on this page')) {
            return;
        }

        setRunStatus('creating');
        setCreateId(issues[0].key);
    }

    const setNextCreateId = (cid) => {
        if (runStatus === '') {
            setCreateId('');
            return;
        }
        if (!issues) {
            setRunStatus('');
            return;
        }

        const pos = issues.findIndex(item => item.key === cid);
        if (issues.length > pos + 1) {
            setCreateId(issues[pos + 1].key);
        } else {
            setCreateId('');
            setRunStatus('');
            alert('Bulk creation completed');
        }
    }

    const viewSprintRuns = () => {

        const params = {
            page: 0,
            jql: `project=SNT AND issuetype = TestCaseRun AND Sprint=${sprint.id} ${version !== '' ? `AND fixVersion="${versionName}"` :''}ORDER BY status ASC` 
        };
        const search = new URLSearchParams(params);
        const queryString = search.toString();
        // history.push(`/jira/${projectId}/jql?${queryString}`);
    }

    const sprint = sprints.find(item => item.id === sprintId);
    let versionName = '';
    const v = versions.find(item => item.id == version);
    if (v) {
        versionName = v.name;
    }

    return <div>
        {dialog === 'run-status' && <StatusWidget projectId={projectId} sprintId={sprintId} closePopup={e => setDialog('')} />}
        <div className="jira-layout">
            <div className="jira-side ds-panel" style={{ padding: 'var(--ds-space-4)' }}>
                <h3 style={{ marginBottom: 'var(--ds-space-4)' }}>{projectId}</h3>

                {sprints && <select name="sprintId" onChange={e => setSprintId(parseInt(e.target.value))}
                    className="ds-select" style={{ marginBottom: 'var(--ds-space-3)' }}>
                    <option value="">Select sprint</option>
                    {sprints.map(item => <option key={item.id} value={item.id}>{item.name} {item.state !== 'active' ? ` - ${item.state}` : ''}</option>)}
                </select>}

                {versions && <select name="versionId" onChange={e => setVersion(e.target.value)}
                    className="ds-select" style={{ marginBottom: 'var(--ds-space-3)' }}>
                    <option value="">Select version</option>
                    {versions.map(item => <option key={item.id} value={item.id}>{item.name}</option>)}
                </select>}

                <input name="token" value={token} type="password" onChange={e => setToken(e.target.value)}
                    className="ds-input" placeholder="Enter your token" />
                {token === '' && <a target="_blank" rel="noreferrer"
                    href="https://id.atlassian.com/manage-profile/security/api-tokens"
                    style={{ fontSize: 'var(--ds-text-xs)', display: 'block', marginTop: 'var(--ds-space-1)' }}>Create your API token here.</a>}

                {sprint && <div className="ds-field-row" style={{ marginTop: 'var(--ds-space-3)', marginBottom: 'var(--ds-space-3)' }}>
                    <button className="ds-btn is-soft is-sm" onClick={renderRunStatus}>Sprint Status</button>
                    <button className="ds-btn is-ghost is-sm" onClick={viewSprintRuns}>Sprint Runs</button>
                </div>}

                <div className="ds-table-wrap">
                    <table className="ds-table">
                        <thead>
                            <tr><th>#</th><th>Component</th></tr>
                        </thead>
                        <tbody>
                            {components && components.map((item, idx) => {
                                return <tr key={item.name} className={item.name === componentId ? 'is-projection' : ''}>
                                    <td className="ds-nums">{idx + 1}</td>
                                    <td>
                                        <Link to={`/jira/${projectId}/${item.name}`} style={{ display: 'inline-flex', alignItems: 'center', gap: '4px' }}>
                                            {item.name} <Icon name="chevronRight" size={14} />
                                        </Link>
                                        <div style={{ fontSize: 'var(--ds-text-xs)', color: 'var(--ds-ink-muted)' }}>{item?.lead?.displayName}</div>
                                    </td>
                                </tr>;
                            })}
                        </tbody>
                    </table>
                    {components == null && <Spinner />}
                </div>
            </div>

            <div>
                <div className="page-head" style={{ justifyContent: 'space-between' }}>
                    <h3>{componentId}</h3>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 'var(--ds-space-2)' }}>
                        {total > 0 && <span style={{ fontSize: 'var(--ds-text-sm)', color: 'var(--ds-ink-muted)' }}>
                            {page * 50 + 1}–{(parseInt(page) + 1) * 50} of {total}</span>}
                        {page > 0 && <Link className="ds-btn is-ghost is-sm"
                            to={`/jira/${projectId}/${componentId}/?jql=${jql}&page=${parseInt(page) - 1}`}>Prev</Link>}
                        {page * 50 < total && <Link className="ds-btn is-ghost is-sm"
                            to={`/jira/${projectId}/${componentId}/?jql=${jql}&page=${parseInt(page) + 1}`}>Next</Link>}
                    </div>
                </div>

                <form onSubmit={handleSearch} action={`/jira/${projectId}/jql`} className="ds-field-row">
                    <input name="jql" className="ds-input ds-field" value={search} onChange={e => setSearch(e.target.value)} />
                    <button id="search_button" className="ds-btn is-primary">Search</button>
                    {(sprint && sprint.state === 'future') && <button className="ds-btn is-soft"
                        disabled={version === ''}
                        type="button" onClick={handleBulkCreate}>{runStatus === '' ? 'Bulk' : 'Cancel'}</button>}
                </form>

                {issues == null && <Spinner />}
                {issues && issues.map((item, idx) => {
                    return <IssueItem key={item.key} components={components}
                        token={token}
                        version={version}
                        projectId={projectId}
                        startId={startId}
                        createId={createId}
                        setNextCreateId={setNextCreateId}
                        item={item} idx={page * 50 + idx}
                        sprint={sprint} />;
                })}
            </div>
        </div>
    </div>;
}